import styled from 'styled-components';

export const ClientsWrapper = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 4rem;

  h2 {
    font-weight: 500;
    color: ${props => props.theme.colors.title_color};
    font-size: clamp(1.5rem, 25px, 5vmin);
    text-align: center;
  }
`;

export const ClientsBox = styled.div`
  width: 100%;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  gap: 3rem;
  flex-wrap: wrap;
  color: ${props => props.theme.colors.footer_text};

  @media screen and (max-width: 600px) {
    justify-content: center;
    gap: 12px;
  }
`;
